
import { Component, Prop, Vue } from 'vue-property-decorator';
import { form18DataInfoType } from '@/types/Information/Form18';

import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{       
        CheckBox           
    }
})
export default class Form18Layout extends Vue {

    @Prop({required:true})
    result!: form18DataInfoType;

    dataReady = false;
    phone = '';
    address = '';

    currentSelfRepresented = false
    currentLawyer = false
    currentLawyerName = ''

    newSelfRepresented = false
    newLawyer = false
    newLawyerName = ''

    mounted(){
        this.dataReady = false;
        this.extractInfo();
        this.dataReady = true;
    }

    public extractInfo(){

        const serviceInfo = this.result.serviceInformation;
        const address =   (serviceInfo.addressLine1? (serviceInfo.addressLine1 + ', '):'')
                        + (serviceInfo.addressLine2? (serviceInfo.addressLine2 + ', '):'') 
                        + (serviceInfo.city? (serviceInfo.city + ', '):'')
                        + (serviceInfo.province? (serviceInfo.province + ', '):'') 
                        + (serviceInfo.country? ( serviceInfo.country + ', '):'')
                        + (serviceInfo.postalCode? serviceInfo.postalCode:'');


        if (!this.result.selfRepresented){
            const counselName = Vue.filter('getFullName')(serviceInfo.counselFirstName, serviceInfo.counselLastName)
            this.address =    (counselName? (counselName + ', '):'')  
                            + (serviceInfo.firmName? (serviceInfo.firmName+ ', '):'') 
                            + address;
            this.phone = serviceInfo.firmPhone;
        } else {
            this.address = address;
            this.phone = serviceInfo.phone;
        }

        this.currentSelfRepresented = (this.result.currentRepresentation == 'Self-represented') && this.result.changeRepresentation
        this.currentLawyer = (this.result.currentRepresentation == 'Lawyer') && this.result.changeRepresentation
        this.currentLawyerName = this.result.changeRepresentation? this.result.currentLawyerName :''

        this.newSelfRepresented = (this.result.newRepresentation == 'Self-represented') && this.result.changeRepresentation
        this.newLawyer = (this.result.newRepresentation == 'Lawyer') && this.result.changeRepresentation
        this.newLawyerName = this.result.changeRepresentation? this.result.newLawyerName :''
           
    }

    
}

